import { useState } from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Box,
  VStack,
  Icon,
  HStack,
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

import { useGetDirectoryByPhaseIdQuery } from '../../../services';
import { CenteredSpinner } from '../../../components';
import { DocumentNavigational } from '.';
import { Directory } from '../../../models';
import { ReactComponent as ChevronRightIcon } from '../../../assets/icons/chevron-right.svg';

export const MoveDocument = ({
  phaseId,
  isOpen,
  onClose,
}: {
  phaseId: string;
  isOpen: boolean;
  onClose: (destinationDirectoryId?: number) => void;
}) => {
  const [selectedDirectory, setSelectedDirectory] = useState<Directory>();
  const { projectId } = useParams();
  const page = 0;

  const { data, isLoading } = useGetDirectoryByPhaseIdQuery({
    projectId: Number(projectId),
    phaseId: Number(phaseId),
    page,
  });

  return (
    <>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <VStack align="flex-start">
              <Text fontSize="md" fontWeight="semibold">
                Move{' '}
                <Box as="span" fontWeight="extrabold">
                  {'Document Name'}
                </Box>{' '}
                to...
              </Text>
            </VStack>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack
              align="start"
              color="custom_blue.1"
              maxH="12rem"
              overflowY="scroll"
            >
              {isLoading ? (
                <CenteredSpinner />
              ) : (
                data?.data.content[0].subDirectories.map(directory => (
                  <DocumentNavigational
                    key={directory.id}
                    directory={directory}
                    selectedDirectory={selectedDirectory}
                    onSelectDirectory={directory =>
                      setSelectedDirectory(directory)
                    }
                  />
                ))
              )}
            </VStack>
          </ModalBody>

          <ModalFooter display="flex" flexDir="column" gap="4">
            <Text alignSelf="flex-start">
              Move to:{' '}
              <HStack>
                {selectedDirectory?.fullPath
                  .split('/')
                  .slice(3)
                  .map((path, index, array) => (
                    <HStack key={path}>
                      <Text
                        textOverflow="ellipsis"
                        overflow="hidden"
                        whiteSpace="nowrap"
                        width="20"
                      >
                        {path}
                      </Text>
                      {index < array.length - 1 ? (
                        <Icon as={ChevronRightIcon} />
                      ) : null}
                    </HStack>
                  ))}
              </HStack>
            </Text>
            <Button
              bg="custom_orange.2"
              _hover={{ bg: 'custom_orange.2' }}
              color="white"
              w="full"
              onClick={() => onClose(selectedDirectory?.id)}
            >
              Move
            </Button>
            <Button onClick={() => onClose()} w="full">
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
